export const readFileChunk = async (file: File, chunkSize: number = 64 * 1024): Promise<string> => {
  const chunk = file.slice(0, Math.min(chunkSize, file.size));
  const chunkText = await chunk.text();
  const lines = chunkText.split('\n');
  return lines.slice(0, 2).join('\n');
};
